var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "item-filter-price" }, [
    _c("div", { staticClass: "input-group" }, [
      _c("div", { staticClass: "input-group-prepend" }, [
        _c("span", { staticClass: "input-group-text" }, [
          _vm._v(_vm._s(_vm.currency)),
        ]),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.priceMin,
            expression: "priceMin",
          },
        ],
        staticClass: "form-control",
        attrs: {
          type: "number",
          placeholder: "Min",
          "aria-label": _vm.$translate("Ceres::Template.itemFilterPriceMin"),
        },
        domProps: { value: _vm.priceMin },
        on: {
          focus: function ($event) {
            return _vm.selectAll($event)
          },
          input: function ($event) {
            if ($event.target.composing) return
            _vm.priceMin = $event.target.value
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "input-group" }, [
      _c("div", { staticClass: "input-group-prepend" }, [
        _c("span", { staticClass: "input-group-text" }, [
          _vm._v(_vm._s(_vm.currency)),
        ]),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.priceMax,
            expression: "priceMax",
          },
        ],
        staticClass: "form-control",
        attrs: {
          type: "number",
          placeholder: "Max",
          "aria-label": _vm.$translate("Ceres::Template.itemFilterPriceMax"),
        },
        domProps: { value: _vm.priceMax },
        on: {
          focus: function ($event) {
            return _vm.selectAll($event)
          },
          input: function ($event) {
            if ($event.target.composing) return
            _vm.priceMax = $event.target.value
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        directives: [{ name: "tooltip", rawName: "v-tooltip" }],
        staticClass: "btn btn-primary btn-appearance",
        class: { disabled: _vm.isDisabled },
        attrs: {
          type: "button",
          "data-toggle": "tooltip",
          "data-placement": "top",
          title: _vm.$translate("Ceres::Template.itemApply"),
          "aria-label": _vm.$translate("Ceres::Template.itemFilterButton"),
        },
        on: {
          click: function ($event) {
            return _vm.triggerFilter()
          },
        },
      },
      [_c("icon", { attrs: { icon: "check", loading: _vm.isLoading } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }